import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessageLines } from '@fortawesome/sharp-solid-svg-icons/faMessageLines';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Button } from 'ui-components/components/button';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import CountryNameMessages from '../../../components/country-names.messages';
import messages from './messages';
import style from './style.module.less';

const getCountryName = (countryCode) => {
  return CountryNameMessages[countryCode];
};

const TaxIdentifierRow = ({ taxIdentifier: row, openDeleteModal }) => {
  const onDeleteClicked = useCallback(() => {
    openDeleteModal(row.taxIdentifierId);
  }, [openDeleteModal, row.taxIdentifierId]);

  return (
    <>
      <div className={classnames([style.cell], style['first-cell'])}>{row.type}</div>
      <div className={style.cell}>
        <FormattedMessage {...getCountryName(row.issuingAuthority)} />
      </div>
      <div className={style.cell}>{row.redactedTaxNumber}</div>
      <div className={style.cell}>{row.name}</div>
      <div className={style.cell}>
        {row.description ? (
          <Tooltip>
            <TooltipContent>{row.description}</TooltipContent>
            <div className={style['note-tooltip']}>
              <FontAwesomeIcon icon={faMessageLines} />
            </div>
          </Tooltip>
        ) : (
          <div className={style['empty-description']}>
            <FontAwesomeIcon icon={faMessageLines} />
          </div>
        )}
      </div>
      <div className={classnames([style.cell], style['last-cell'])}>
        <Button className={style['delete-row']} onClick={onDeleteClicked} theme='link'>
          <FormattedMessage {...messages.delete} />
        </Button>
      </div>
    </>
  );
};

TaxIdentifierRow.propTypes = {
  taxIdentifier: PropTypes.shape({
    taxIdentifierId: PropTypes.string,
    taxIdentifierType: PropTypes.string,
    issuingAuthority: PropTypes.oneOf(Object.keys(CountryNameMessages)),
    redactedTaxNumber: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  openDeleteModal: PropTypes.func.isRequired,
};

export default TaxIdentifierRow;
